module.exports = __webpack_public_path__ + "img/huawei.8f5bca86.png";